export enum FileUploaderType {
  IMAGE = 0,
  VIDEO = 1,
  SLIDE = 2,
}
